import React from 'react'
import 'antd/dist/reset.css';
import { Route, Routes } from 'react-router-dom'
import AccountList from './sys/account/AccountList'
import ArapAddOld from './sys/arap/ArapAddOld'
import ArapList from './sys/arap/ArapList'
import BalanceList from './sys/balance/BalanceList'
import BalanceTypeList from './sys/balanceType/BalanceTypeList'
import ClientList from './sys/client/ClientList'
import ClientTypeList from './sys/clientType/ClientTypeList'
import DeptList from './sys/dept/DeptList'
import FundList from './sys/fund/FundList'
import GoodsList from './sys/goods/GoodsList'
import GoodsTypeList from './sys/goodsType/GoodsTypeList'
import Home from './web/Home'
import LedgerList from './sys/ledger/LedgerList'
import Login from './web/Login'
import LoginGate from './cpn/LoginGate'
import NoPower from './sys/NoPower'
import Password from './sys/Password'
import PostList from './sys/post/PostList'
import Regist from './web/Regist'
import StatForm from './sys/statForm/StatForm'
import StatIndex from './sys/statForm/StatIndex'
import StatIndexPersonal from './sys/statForm/StatIndexPersonal'
import SysIndex from './sys/SysIndex'
import UserList from './sys/user/UserList'

function App() {    
 
    return (    
        <Routes>        
            <Route path='/' element={<Home />}></Route>
            <Route path='/Login' element={<Login />}></Route>
            <Route path='/Regist' element={<Regist />}></Route>
            <Route path='/' element={<LoginGate />}>
                <Route path='/SysIndex' element={<SysIndex />}></Route>
                <Route path='/AccountList' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('82')?<NoPower/>:<AccountList />)}></Route>
                <Route path='/ArapAddOld' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('86')?<NoPower/>:<ArapAddOld />)}></Route>
                <Route path='/ArapList' element={<ArapList />}></Route>
                <Route path='/BalanceList' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('84')?<NoPower/>:<BalanceList />)}></Route>
                <Route path='/BalanceTypeList' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('83')?<NoPower/>:<BalanceTypeList />)}></Route>
                <Route path='/ClientList' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('89')?<NoPower/>:<ClientList />)}></Route>
                <Route path='/ClientTypeList' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('76')?<NoPower/>:<ClientTypeList />)}></Route>
                <Route path='/DeptList' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('78')?<NoPower/>:<DeptList/>)}></Route>
                <Route path='/FundList' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('87')?<NoPower/>:<FundList />)}></Route>
                <Route path='/GoodsList' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('88')?<NoPower/>:<GoodsList />)}></Route>
                <Route path='/GoodsTypeList' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('77')?<NoPower/>:<GoodsTypeList />)}></Route>
                <Route path='/LedgerList' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('90')?<NoPower/>:<LedgerList />)}></Route>
                <Route path='/Password' element={<Password />}></Route>
                <Route path='/PostList' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('81')?<NoPower/>:<PostList />)}></Route>
                <Route path='/StatForm' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('85')?<NoPower/>:<StatForm />)}></Route>
                <Route path='/StatIndex' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('85')?<NoPower/>:<StatIndex />)}></Route>
                <Route path='/StatIndexPersonal' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('85')?<NoPower/>:<StatIndexPersonal />)}></Route>
                <Route path='/UserList' element={localStorage.getItem('eu_id') && (localStorage.getItem('ess_menu_id').includes('79')?<NoPower/>:<UserList />)}></Route>
            </Route>
        </Routes>   
    )
}

export default App